module.exports = __webpack_public_path__ + "static/media/mail.f99d2ee1.png";